export const ACTION_TYPES = {
	SET_PROCESSING_METHOD: 'SET_PROCESSING_METHOD',
	SET_CARRIER: 'SET_CARRIER',
	SET_DATE: 'SET_DATE',
	SET_TIMESLOT: 'SET_TIMESLOT',
	SET_DATES: 'SET_DATES',
	SET_TIMESLOTS: 'SET_TIMESLOTS',
	UPDATING_DATES: 'UPDATING_DATES',
	INITIALIZED: 'INITIALIZED',
};
